export default {
  message: {
    hello: '你好',
    welcome: '欢迎来到我们的网站！',
    login: '登录',
    logout: '退出',
    about: '关于我们',
    contact: '联系我们',
    news: '新闻资讯',
    home: '首页',
    industry: '行业应用',
    support: '服务与支持',
    faq: '常见问题',
    privacy: '隐私条款',
    userCenter: '用户中心',
    myOrder: '我的订单',
    myPlan: '我的套餐',
    myTeam: '我的团队',
    myInfo: '个人资料',
    myMessage: '我的消息',
    exit: '退出登录',
    language: '语言',
    zh: '中文',
    en: '英文',
    ja: '日语',
    ko: '韩语',
    industryNews: '行业新闻',
    techNews: '技术动态',
    service: '客服咨询',
    onlineExperience: '在线体验极致压缩',
    getPro: '获取个人PRO会员解锁权限',
    originalImage: '原始图片',
    compressed: '压缩后',
    saveSpace: '节省空间',
    imageCompress: '图片压缩',
    supportedImage: '支持JPG/JPEG/PNG/GIF/WebP',
    addImage: '添加图片',
    visitorImageTip: '访客：每次可上传20张图片，每张图片最大限制为5MB',
    originalVideo: '原始视频',
    videoCompress: '视频压缩',
    supportedVideo: '支持MP4/MOV/AVI/MKV/TS/FLV/Y4M/YUV',
    addVideo: '添加视频',
    visitorVideoTip: '访客：每次仅上传一个视频，每个视频最大限制为60MB',
    scrollDown: '往下滑，还有些更酷的',
    windows32: 'Windows(32位)下载',
    windows64: 'Windows(64位)下载',
    selectedUsers: '已有',
    users: '用户选择',
    ourPartners: '我们的合作伙伴',
    localCompressSoftware: '本地视频及图像压缩软件',
    noFileLimit: '无文件数量及大小限制',
    vipRights: '共享VIP权益｜线上+本地',
    customCompress: '自定义压缩设置，满足不同需求',
    folderOneClick: '文件夹一键压缩',
    address: '深圳市南山区桃源街道笃学路9号国家超级计算深圳中心科研楼7楼',
    quickNav: '快捷导航',
    technologyIntro: '技术介绍',
    price: '价格',
    copyright: '深圳智慧林网络科技有限公司',
    icp: '粤ICP备20048602号-2',
    legal: '法律声明',
    siteMap: '网站地图',
    newsBannerTitle: 'ZHL压缩技术行业应用',
    newsBannerDesc: 'ZHL压缩（API/SDK）高效.安全.快速.专业',
    contactForApi: '请联系我们获取API/SDK',
    getDoc: '获取说明文档',
    techFeatures: '技术特点',
    efficientConvenient: '高效便捷',
    efficientConvenientDesc: 'API/SDK压缩方案成熟，标准化文档+全程技术支持，让企业开发接入更加便捷，快速享受ZHL压缩技术',
    safeStable: '安全稳定',
    safeStableDesc: '经受上亿次测试，服务器安全稳定，传输数据完全加密；压缩处理后自动删除用户数据，保障用户隐私安全。',
    powerfulAlgorithm: '强大算法',
    powerfulAlgorithmDesc: '基于多种独立自研算法，通过海量数据训练以及实战业务场景支撑，致力保障源文件完整性。',
    multiLanguageSupport: '多语言及多系统支持',
    multiLanguageSupportDesc: '多种编程语言C、 C++、Java、go等适用Linux和windows平台，如需个性化定制服务，请联系我们。',
    techAdvantages: '技术优势',
    techAdvantagesDesc: '自主知识产权独立算法,底层可控可调（可根据客户需求灵活调整压缩策略）；基于人工智能及机器学习技术，效果可持续优化；压缩比、压缩速度、压缩质量行业领先（视具体文件格式程度不等）；基于数学关系和AI自学习架构，占用资源少，硬件要求低，可灵活部署；支持文件文件类型广，多系统支持；无损压缩可确保文件完整性，性能领先头部软件70-80%（如7-ZIP等软件）；',
    techPrinciples: '技术原理',
    techPrinciplesDesc: '通过机器学习和AI模型分析数百万级数据，发现其中数学关系,并采用自研算法处理不同类型文件中的数据和二进制信息，从而可对以往不可压缩的文件类型进行压缩，并做到100%无损。',
    imageCompressSdk: '图片压缩SDK',
    medicalImageSdk: '医疗影像压缩SDK',
    textLogSdk: '文本&log压缩SDK',
    videoStreamSdk: '视频流实时压缩SDK',
    supportedFormats: '支持格式及操作系统',
    supportedFormatsImage: '支持格式：bmp/jpg/png/tif/gif/pcx/tga/exif/fpx/svg/psd/cdr/pcd/dxf/ufo/eps/ai/raw/webp系统：SDK 基于 Java，支持 Linux 和 Windows 系统',
    supportedFormatsMedical: 'DICOM/NIFTI系统：基于Java语言，支持Linux和Windows。',
    supportedFormatsText: '支持格式：text/RTF/jsonlog/sql/xml/doc//MIME/ASCII…系统：基于Java语言，支持Linux和Windows',
    supportedFormatsVideo: 'mp4/mov/mkv/avi/rm/rmvb/mpeg1-4/dat/wmv/3gp/amv/dmv/fl系统：基于C++ 语言,支持Linux和 Windows 系统。',
    painPoints: '痛点与需求',
    painPointsImage: '高清图档加载及传输速度慢海量图片平台存储压力大海量储存成本高jpeg格式不支持无损压缩',
    painPointsMedical: '影像数据数据规模庞大（标准病理检查可达5G/个）历史数据多、保存时间长（10年+）需完全无损压缩（图像不可失真）',
    painPointsText: '重复冗余数据拥堵用户数据暴涨',
    painPointsVideo: '节省带宽月租成本减少NVR服务器采购扩充费用节省存储、备份归档资源，降低运行和管理成本降低计算机或存储设备运行负荷',
    featuresEffects: '特点及效果',
    featuresEffectsImage: '高质量压缩品质保留、有效节省存储空间及费用、加速文件流转、节省机房建设成本、节省带宽月租成本、加快网页加载速度。',
    featuresEffectsMedical: '大幅度降低存储空间、延长医疗机构购买存储/备份/归档设备周期，降低存储/备份/归档成本；极大地节约存储/备份/归档资源，降低运行和管理成本；降低计算机或存储设备运行负荷；加快了数据传输的速度，大大提升用户体验；提高影像数据检索和调用效率；',
    featuresEffectsText: '5种压缩速度可选；压缩后文件更小传输更快；解压文件成本低于存储和传输成本。',
    featuresEffectsVideo: '金融、数据中心、边缘计算等、区块链、物联网等。安防监控、120急救车、指挥中心智慧交通等。',
    suitableScenarios: '适宜场景',
    suitableScenariosImage: '文博、档案馆、金融行业、政府单位、大型网购平台、新媒体、素材库、影视等',
    suitableScenariosMedical: '主要应用于医疗机构的PACS系统、医疗影像云等场景',
    suitableScenariosText: '金融、数据中心、边缘计算等、区块链、物联网等',
    suitableScenariosVideo: '安防监控、120急救车、指挥中心智慧交通等',
    faqTitle: '常见问题',
    faqBreadcrumbHome: '首页',
    faqBreadcrumbService: '服务与支持',
    faqBreadcrumbFaq: '常见问题',
    faqQuestionAnswer: '问题解答',
    faqQ1Title: '访客和PRO会员用户有什么区别？',
    faqQ1Content: '访客在使用图像压缩功能时，可以一次性上传最多20张图片，并且每张图片最大限制为5MB；PRO会员用户可以一次性无限制上传图像，且每张图片大小无限制。访客在使用视频压缩功能时，可以一次性上传1个视频文件，每个视频文件最大限制为60MB；PRO会员用户可以一次性上传一份视频文件，每个视频文件最大限制为2GB。',
    faqQ2Title: '如何成为PRO会员用户',
    faqQ2Content: '用户可以通过邮箱、微信的方式登录我们的网站，成为用户后，可点击"价格"进入PRO会员购买界面，支付购买后即可成为我们尊贵的PRO会员。',
    faqQ3Title: '上传的图像/视频会怎么处理呢？',
    faqQ3Content: '用户所上传的文件会通过我们后台服务器进行压缩，压缩完后由用户自行下载。我们只会保留这些文件一个小时，用以记录我们对文件的压缩情况从而优化我们的压缩技术。一个小时后便立即删除，无任何隐私泄露风险。',
    faqQ4Title: '如何申请发票？',
    faqQ4Content: '在Yasubit消费满100元的用户可以通过客服qq来联系Yasubit团队开具发票。',
    faqQ5Title: '拖拽上传图像或视频的时候不成功？',
    faqQ5Content: '由于不同浏览器版本新旧不统一，因此一些用户在使用我们的在线服务时可能会遇到一些压缩或上传不成功的问题。我们在这里建议大家使用Google的Chrome或者火狐浏览器。',
    faqQ6Title: '怎么使用压缩偏好设置？',
    faqQ6Content: '在使用图像压缩的时候，用户可以根据自己的需求选择压缩质量。压缩质量越高（1是最高），压缩后的文件越大；压缩质量越低（13是最低），压缩后的文件越小。视频压缩与图像压缩的原理相同。但是视频压缩除了可以选择压缩质量以外，还可以选择视频的输出格式。在不改变压缩偏好设置的情况下（默认模式），压缩比和压缩质量会处于平衡状态，即压缩后的视频或图像在视觉和听觉上与原视频或图像没有区别。',
    faqQ7Title: '为何有些图像和视频压缩后并没有变小太多？',
    faqQ7Content: 'Yasubit对于绝大部分的视频和图像都可以做到非常好的压缩效果。而对于部分压缩效果一般的视频和图像，其原因主要是这些视频和图像已经被深度压缩过。因此无法进一步再压缩，否则会带来视觉上的明显差异。如果用户需要获得更小的压缩视频和图像，可以通过设置压缩偏好来完成。',
    faqQ8Title: 'Yasubit客户端软件VIP和Yasubit网站PRO会员账户是否通用？',
    faqQ8Content: 'Yasubit客户端VIP可在Yasubit网站上登陆使用，享受网站同等PRO会员的压缩权限，反之，网站上的PRO会员也可以在客户端登陆使用，享受客户端同等VIP的压缩权限，建议下载客户端使用，文件大小及数量都不受限制。',
    // Contact page translation keys
    contactTitle: '联系我们',
    contactBreadcrumbHome: '首页',
    contactBreadcrumbService: '服务与支持',
    contactBreadcrumbContact: '联系我们',
    customerService: '客服咨询',
    customerServiceQQ: 'QQ: 3985723352',
    contactCustomerService: '联系客服',
    businessCooperation: '商务合作',
    businessCooperationDesc: '关于商务合作请通过邮件联系我们。',
    businessEmail: '邮箱：support@zhihuilin.net',
    leaveMessage: '留言给我们',
    yourName: '您的称呼：',
    contactInfo: '联系方式：',
    yourEmail: '您的邮箱：',
    messageContent: '留言内容（200字内）',
    submit: '提交',
    submitSuccess: '提交成功',
    submitFailed: '提交失败，请稍后重试',
    completeInfo: '需填写完整信息',
    // About page translation keys
    aboutTitle: '关于我们',
    aboutBreadcrumbHome: '首页',
    aboutBreadcrumbAbout: '关于我们',
    companyProfile: '公司简介',
    companyProfileContent: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <a href="http://www.zhihuilin.net/" target="_blank" title="ZHL官网">深圳智慧林网络科技有限公司</a> ，成立于2015年，是一家致力于人工智能、数据压缩、通信传输加速等技术底层算法及其应用研发的国家高新技术企业，先后研发出了拥有完全自主知识产权的新一代人工智能核心算法和深度学习技术、世界领先水平的数据超压缩技术、全球创新的通信传输加速等技术，并利用这些技术为广大政、企客户提供行业应用解决方案和定制化产品。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 公司自2017年至今多次被认定为国家高新技术企业，是科技部火炬中心科技型中小企业、深圳市创新型中小企业、高成长企业；深圳市软件行业协会理事单位、深圳市信息技术应用创新联盟会员单位、工业互联网联盟、工信部科产金项目库首批入驻项目；为保持科技创新能力，公司引进了四位（A类）外国专家，其中两位分别荣获外国高端人才和广东省外籍高层次人才称号；已申报完全自主知识产权的核心技术发明专利63件,获得授权发明专利证书7件、其他授权专利证书9件、申请PCT国际专利8件、软件著作权证书66件、科技查新报告和软件测试报告40多件、注册商标12项;为科学、规范管理，公司通过了ISO 9001质量管理体系认证、知识产权管理体系认证。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 公司将坚持以"诚信为本、持续创新、尽最大努力满足客户需求"为宗旨，用过硬的产品和优质的服务，为客户降本增效和节能减排赋能，实现合作共赢。<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style="font-size: 20px;">底层技术持续创新&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 完全自主知识产权&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 近10年理论及技术沉淀<br/><br/><br/></span><br/><br/>',
    companyHonor: '相关资质',
    softwareCopyright: '软件著作权',
    patentApplied: '已申报发明专利',
    patentGranted: '已授权发明专利',
    // Privacy page translation keys
    privacyTitle: '隐私条款',
    privacyBreadcrumbHome: '首页',
    privacyBreadcrumbService: '服务与支持',
    privacyBreadcrumbPrivacy: '隐私条款',
    privacyContent: `任何单位或个人在使用 Yasubit图像压缩服务之前，均应仔细阅读本条款，如不同意本条款可停止使用 Yasubit 的服务，一旦使用，即被视为对本条款全部内容的认可和接受。 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>&nbsp; &nbsp; &nbsp; &nbsp;一、任何单位或个人通过 Yasubit 压缩的多媒体文件包括生成的临时URL链接，均系该用户或所有者制作提供（以下简称"第三方文件"）。Yasubit 只提供在线压缩和减少字节能力，并不是也不反映 Yasubit 之任何意见和主张，也不表示 Yasubit 同意或支持该等第三方文件的任何内容、主张或立场。Yasubit 对第三方文件中内容之合法性、准确性、真实性、适用性、安全性等概不负责，也无法负责。 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>&nbsp; &nbsp; &nbsp; &nbsp;二、Yasubit 所提供的在线智能压缩能力不得不首先临时存储第三方文件，但 Yasubit 并不会长期存储第三方文件，任何单位或个人所提交/上传的全部文件，每隔60分钟自动删除，删除后文件链接既失效，请勿过渡依赖 Yasubit 所提供的文件链接。 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>&nbsp; &nbsp; &nbsp; &nbsp;三、任何单位或个人不得利用 Yasubit 上传、压缩、下载、复制、发布、传播或者转载如下内容： &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>&nbsp; &nbsp; &nbsp; &nbsp;1、反对宪法所确定的基本原则的； &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>&nbsp; &nbsp; &nbsp; &nbsp;2、危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的； &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>&nbsp; &nbsp; &nbsp; &nbsp;3、损害国家荣誉和利益的； &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>&nbsp; &nbsp; &nbsp; &nbsp;4、煽动民族仇恨、民族歧视，破坏民族团结的； &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>&nbsp; &nbsp; &nbsp; &nbsp;5、破坏国家宗教政策，宣扬邪教和封建迷信的； &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>&nbsp; &nbsp; &nbsp; &nbsp;6、散布谣言，扰乱社会秩序，破坏社会稳定的； &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>&nbsp; &nbsp; &nbsp; &nbsp;7、散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的； &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>&nbsp; &nbsp; &nbsp; &nbsp;8、侮辱或者诽谤他人，侵害他人合法权益的； &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>&nbsp; &nbsp; &nbsp; &nbsp;9、含有法律、行政法规禁止的其他内容的信息。 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>&nbsp; &nbsp; &nbsp; 四、任何单位或个人如需要第三方文件中的内容（包括图片、音频、视频、文档、链接等），并欲据此进行交易或其他行为前，应慎重辨别这些内容的合法性、准确性、真实性、实用性和安全性（包括下载第三方文件中内容是否会感染电脑病毒），并采取谨慎的预防措施。如您不确定这些内容是否合法、准确、真实、实用和安全，Yasubit 建议您先咨询专业人士。 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>&nbsp; &nbsp; &nbsp; 五、任何单位或者个人因相信、使用第三方文件中信息、服务、产品等内容，或据此进行交易等行为，而引致的人身伤亡、财产毁损（包括因下载而感染电脑病毒）、名誉或商誉诽谤、版权或知识产权等权利的侵犯等事件，及因该等事件所造成的损害后果，Yasubit 概不负责，亦不会也不能承担任何法律责任，而应由第三方文件的所有者承担。无论何种原因，Yasubit 不对任何非与 Yasubit 直接发生的交易和行为承担任何直接、间接、附带或衍生的损失和责任。 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>&nbsp; &nbsp; &nbsp; &nbsp;六、任何单位或个人如认为通过 Yasubit 服务所得的第三方文件中内容可能涉嫌侵害其合法著作权，应按照《信息网络传播权保护条例》的规定，以书面的形式及时向 Yasubit 反应，并提供相应身份证明、权属证明及详细的侵权情况证明，Yasubit 在收到上述文件后，会尽快断开对该内容的相关服务的链接。如果该等被断开链接的第三方文件所有者认为被提出权利主张的 Yasubit 结果并未侵害他人合法著作权的，亦有权按照《信息网络传播权保护条例》的规定，向 Yasubit 发出关于被断开链接不违反《信息网络传播权保护条例》的反通知。Yasubit 提醒您注意：如您的主张侵权或主张不侵权的陈述失实，您将按照《信息网络传播权保护条例》的规定，承担相关法律责任。 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>&nbsp; &nbsp; &nbsp; 七、Yasubit 可根据国家法律法规变化及维护用户权益需要，不时修改本条款，变更后的条款将通过法定程序在本条款中明显标注及注明最后的更新日期。`,
    buyNow: '购买',
    payTip: '我们支持微信支付。请仔细阅读隐私条款。如若购买了我们的服务，说明您自动同意该 ',
    invoiceTip: '*累计消费超过100元可添加客服qq开具发票了，支持开具普通发票和专用发票',
    price_1: '每日会员',
    price_2: '月度会员',
    price_3: '年度会员',
    price_4: '2年会员',
    price_5: '5年会员',
    price_6: '10年会员',
    price_7: '永久会员',
    price_8: '季度会员',
    price_desc_1: '日会员仅限网站使用<br>无限制图像数量<br>无限制文件大小',
    price_desc_2: '客户端无限制视频大小<br>无限制图像数量<br>无限制文件大小',
    price_desc_3: '客户端无限制视频大小<br>无限制图像数量<br>无限制文件大小',
    price_desc_4: '客户端无限制视频大小<br>无限制图像数量<br>无限制文件大小',
    price_desc_5: '客户端无限制视频大小<br>无限制图像数量<br>无限制文件大小',
    price_desc_6: '客户端无限制视频大小<br>无限制图像数量<br>无限制文件大小',
    price_desc_7: '客户端无限制视频大小<br>无限制图像数量<br>无限制文件大小',
    price_desc_8: '客户端无限制视频大小<br>无限制图像数量<br>无限制文件大小',
    priceTitle: '选择符合您工作场景的购买计划',
    proMemberCount: '已有3876人成为PRO版会员',
    personalVersion: '个人版',
    teamVersion: '团队版',
    videoImageCompress: '视频+图像压缩',
    duration: '使用时长',
    unlimitedVideoSize: '客户端无限制视频大小',
    unlimitedImageCount: '无限制图像数量',
    unlimitedFileSize: '无限制文件大小',
    selectTeamMember: '请选择团队成员数',
    selectDuration: '请选择会员时长',
    selectPackage: '请选择套餐',
    needMoreHelp: '需要更多帮助？',
    confirmPurchase: '您确定要吗？您确定要吗？您确定要吗？您确定要吗？您确定要吗？您确定要吗？',
    yes: '是',
    no: '否',
    orderCreatedSuccess: '创建订单成功',
    orderName: '订单名称',
    orderAmount: '订单金额',
    payMethod: '支付方式',
    orderStatus: '交易状态',
    action: '操作',
    pending: '待支付',
    paid: '已支付',
    applyInvoice: '申请发票',
    delete: '删除',
    goPay: '去支付',
    noData: '暂无',
    planName: '套餐名称',
    planType: '套餐类型',
    memberTime: '会员时间',
    memberCount: '使用成员数',
    personal: '个人',
    team: '团队',
    daysLeft: '剩余{days}天',
    teamInfo: '团队信息',
    teamId: '团队ID',
    teamMemberCount: '团队人数',
    teamPlanName: '套餐名称',
    teamPlanTime: '套餐时间',
    myMembers: '我的成员',
    admin: '管理员',
    addMember: '添加新成员',
    inputNewMemberId: '请输入新成员ID',
    add: '添加',
    createTeam: '创建团队',
    noTeamTips: '您还没有团队，点击创建团队吧',
    userName: '用户名',
    userId: 'ID号',
    password: '密码',
    changePassword: '修改密码',
    bindEmail: '绑定邮箱',
    bindInviter: '绑定邀请人手机号',
    changePasswordTitle: '修改密码',
    oldPassword: '请输入旧密码',
    newPassword: '请输入新密码',
    repeatNewPassword: '请重复新密码',
    passwordRule: '8-20位密码，字母/数字/符号至少两种',
    confirm: '确认',
    cancel: '取消',
    deleteSuccess: '删除成功',
    passwordNotMatch: '两次输入的新密码不一致！',
    changeSuccess: '修改成功，请重新登录',
    remove: '移除',
    people: '人',
    fileName: '文件名称',
    originalFileSize: '原文件大小',
    status: '状态',
    compressedFileSize: '压缩后文件大小',
    fileSizeReduced: '文件大小减少',
    merging: '合并中...',
    resume: '继续',
    pause: '暂停',
    download: '下载',
    clickOrDragToAddImage: '点击或拖拽添加图片',
    continueToAddImage: '继续添加图片',
    startCompress: '开始压缩',
    uploading: '上传中',
    compressing: '压缩中',
    downloadAll: '下载全部',
    startDownloading: '开始打包并下载，请稍候…',
    uploadedCount: '共上传{count}图片',
    downloadFailed: '下载失败，请重试',
    uploadComponentInitFailed: '上传组件初始化失败，请刷新页面重试。',
    imageAlreadyExists: '该图片已存在',
    allFilesExist: '所有文件都已存在',
    guestMaxUpload: '访客用户每次最多只能上传{count}张图片。',
    guestImageSizeLimit: '图片{name}超过{size}MB限制。访客用户上传的图片不能超过{size}MB。',
    uploadFailed: '{name} 上传失败: {msg}',
    noDownloadableFiles: '没有可下载的压缩文件',
    createZipFailed: '创建压缩包失败，请重试',
    resumeUploadFailed: '恢复上传失败，请重试',
    pauseUploadFailed: '暂停上传失败，请重试',
    unknownError: '未知错误',
    guestSurveyTitle: 'Yasubit网站体验调查问卷',
    questionCount: '共{count}个问题',
    fillTextareaPlaceholder: '不少于5个字',
    fillAllQuestions: '请填写完整问卷',
    compressionFailed: '压缩失败',
    compressionFailedWithName: '{name} 压缩失败',
    clickOrDragToAddVideo: "点击或拖拽添加视频",
    continueToAddVideo: "继续添加视频",
    profile: '个人资料',
    guestQ1: '1.请问您的性别是？',
    guestQ1_option1: '男',
    guestQ1_option2: '女',
    guestQ2: '2.请问您的年龄是？',
    guestQ2_option1: '18岁以下',
    guestQ2_option2: '18~24岁',
    guestQ2_option3: '24~32岁',
    guestQ2_option4: '32岁以上',
    guestQ3: '3.请问您是从事哪方面工作的？',
    guestQ3_option1: 'IT',
    guestQ3_option2: '设计',
    guestQ3_option3: '摄影',
    guestQ3_option4: '教师',
    guestQ3_option5: '学生',
    guestQ3_option6: '行政/财务',
    guestQ3_option7: '其他',
    guestQ4: '4.请问您日常关注哪些类型的内容？',
    guestQ4_option1: '原创视频',
    guestQ4_option2: '设计材料',
    guestQ4_option3: '摄影',
    guestQ4_option4: 'IT咨询',
    guestQ4_option5: '其他',
    guestQ5: '5.请问您压缩文件的目的是？',
    guestQ5_option1: '网站建设需要',
    guestQ5_option2: '上传文件',
    guestQ5_option3: '发送文件',
    guestQ5_option4: '提高程序运行速度',
    guestQ5_option5: '其他',
    guestQ6: '6.请问您平均多长时间会使用我们的网站？',
    guestQ6_option1: '每天',
    guestQ6_option2: '每周',
    guestQ6_option3: '每月',
    guestQ6_option4: '临时',
    guestQ7: '7.您希望作为Pro会员还能享受什么服务？',
    guestQ7_placeholder: '请填写您的建议，不少于五个字',
    guestQ8: '8.您是从什么渠道知道我们的网站呢？',
    guestQ8_option1: '百度搜索',
    guestQ8_option2: '论坛（知乎、贴吧、CSDN等）',
    guestQ8_option3: '朋友推荐',
    guestQ8_option4: '其他',
    guestQ9: '9.请问您对我们网站在线压缩功能是否满意？',
    guestQ9_option1: '满意',
    guestQ9_option2: '不满意',
    guestQ10: '10.您对我们有什么建议？',
    unsupportedImageFormat: '不支持的图片格式',
    unsupportedVideoFormat: '不支持的视频格式',

  }
} 